<template>
<div>
    <div v-if="loading" class="loading-spin">
        <SpinnerLoader :color="'#3c5d3d'" />
    </div>
    <div v-else :style="{ 'filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', '-webkit-filter' : data.impairedRegime ? 'grayscale(1)' : 'grayscale(0)', 'background' : data.impairedRegime ? '#ffffff' : '#f2f2f2', 'color' : data.impairedRegime ? '#000000' : '#333333' }" class="outer flex-col">
        <directory :route="$route"></directory>
        <h1 v-if="lang === 'ru'">Вопросы и ответы</h1>
        <h1 v-if="lang === 'kk'">Сұрақ-Жауап</h1>
        <div @click="showTagList()" class="flex-row tag-mobile">
            <div  v-if="lang === 'ru'">{{ translate[filter] }}</div>
            <div  v-if="lang === 'kk'">{{ translateKz[filter] }}</div>
            <svg style="margin: 18px 0 0 10px;" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.86667 0.0664062L8 6.19979L14.1333 0.0664062L16 1.93312L8 9.93307L0 1.93312L1.86667 0.0664062Z" fill="#568357"/>
            </svg>
        </div>
        <div class="content flex-row">
            <div class="left flex-col">
                <div @click="showTagList()" class="category flex-col">
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'last' } })" v-bind:class="{ 'active' : filter === 'last' }" class="category-item">Недавно заданные вопросы</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'last' } })" v-bind:class="{ 'active' : filter === 'last' }" class="category-item">Жақында қойылған сұрақтар</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'for-girls' } })" v-bind:class="{ 'active' : filter === 'for-girls' }" class="category-item">Для девочек</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'for-girls' } })" v-bind:class="{ 'active' : filter === 'for-girls' }" class="category-item">Қыздарға</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'for-boys' } })" v-bind:class="{ 'active' : filter === 'for-boys' }" class="category-item">Для мальчиков</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'for-boys' } })" v-bind:class="{ 'active' : filter === 'for-boys' }" class="category-item">Ұлдарға</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'pregnancy' } })" v-bind:class="{ 'active' : filter === 'pregnancy' }" class="category-item">Беременность</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'pregnancy' } })" v-bind:class="{ 'active' : filter === 'pregnancy' }" class="category-item">Жүктілік</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'STD' } })" v-bind:class="{ 'active' : filter === 'STD' }" class="category-item">Инфекции, передающиеся половым путем</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'STD' } })" v-bind:class="{ 'active' : filter === 'STD' }" class="category-item">Жыныстық жолмен жұғатын инфекциялар</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'aids' } })" v-bind:class="{ 'active' : filter === 'aids' }" class="category-item">Вирус иммунодефицита человека</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'aids' } })" v-bind:class="{ 'active' : filter === 'aids' }" class="category-item">Адамның иммун тапшылығы вирусы</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'viral-hepatitis' } })" v-bind:class="{ 'active' : filter === 'viral-hepatitis' }" class="category-item">Вирусные гепатиты</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'viral-hepatitis' } })" v-bind:class="{ 'active' : filter === 'viral-hepatitis' }" class="category-item">Вирустық гепатиттер</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'sexual-assault' } })" v-bind:class="{ 'active' : filter === 'sexual-assault' }" class="category-item">Сексуальное насилие</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'sexual-assault' } })" v-bind:class="{ 'active' : filter === 'sexual-assault' }" class="category-item">Жыныстық зорлық-зомбылық</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'cyberbullying' } })" v-bind:class="{ 'active' : filter === 'cyberbullying' }" class="category-item">Кибербуллинг</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'cyberbullying' } })" v-bind:class="{ 'active' : filter === 'cyberbullying' }" class="category-item">Кибербуллинг</span>
                    <span v-if="lang === 'ru'" @click="$router.push({ name: 'faq', query: { filter: 'for-parents' } })" v-bind:class="{ 'active' : filter === 'for-parents' }" class="category-item">Родителям</span>
                    <span v-if="lang === 'kk'" @click="$router.push({ name: 'faq', query: { filter: 'for-parents' } })" v-bind:class="{ 'active' : filter === 'for-parents' }" class="category-item">Ата-аналарға арналған</span>
                </div>
                <div class="not-found flex-col">
                    <span v-if="lang === 'ru'">Не нашли ответ?</span>
                    <span v-if="lang === 'kk'">Жауап таппадыңыз ба?</span>
                    <div v-if="lang === 'ru'" @click="$router.push({ name: 'ask-question' })" class="ask-q">Задать вопрос</div>
                    <div v-if="lang === 'kk'" @click="$router.push({ name: 'ask-question' })" class="ask-q">Сұрақ қою</div>
                </div>
            </div>
            <div class="right flex-col">
                <div class="questions-list flex-col">
                    <div v-for="data in activeFAQ" :key="data.id" class="question-item">
                        <!-- filter( i => dataFAQ.indexOf(i) < 4 ) -->
                        <div :id="data.id" class="info flex-col">
                            <div class="faq-answer" v-html="data.attributes.field_description.value">

                            </div>
                            <span v-if="lang === 'ru'" class="feedback-text on-click-active">Вы смогли получить ответ на свой вопрос?</span>
                            <span v-if="lang === 'kk'" class="feedback-text on-click-active">Сұрағыңызға жауап таптыңыз ба?</span>
                            <div v-if="!sentFeedback" class="feedback-btns on-click-active flex-row">
                                <div v-if="lang === 'ru'" @click="sentFeedback = true" class="option yes">Да</div>
                                <div v-if="lang === 'kk'" @click="sentFeedback = true" class="option yes">Иә</div>
                                <div v-if="lang === 'ru'" @click="sentFeedback = true" class="option no">Нет</div>
                                <div v-if="lang === 'kk'" @click="sentFeedback = true" class="option no">Жоқ</div>
                            </div>
                            <div v-if="sentFeedback" class="feedback-btns on-click-active flex-row">
                                <div class="icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.0435 14.7415C16.8286 14.549 16.4983 14.5677 16.3068 14.7822C15.2185 15.9983 13.6491 16.6954 11.9999 16.6954C10.3512 16.6954 8.78126 15.9983 7.69291 14.7822C7.50039 14.5677 7.17117 14.549 6.95621 14.7415C6.74126 14.9335 6.72352 15.2632 6.91552 15.4782C8.20161 16.915 10.0548 17.7389 11.9999 17.7389C13.9454 17.7389 15.7987 16.9145 17.0842 15.4782C17.2762 15.2632 17.258 14.9335 17.0435 14.7415Z" fill="#568357"/>
                                        <path d="M12 0C5.3833 0 0 5.3833 0 12C0 18.6167 5.3833 24 12 24C18.6167 24 24 18.6167 24 12C24 5.3833 18.6167 0 12 0ZM12 22.9565C5.95826 22.9565 1.04348 18.0417 1.04348 12C1.04348 5.95826 5.95826 1.04348 12 1.04348C18.0417 1.04348 22.9565 5.95826 22.9565 12C22.9565 18.0417 18.0417 22.9565 12 22.9565Z" fill="#568357"/>
                                        <path d="M16.1739 8.34766C14.7354 8.34766 13.5652 9.51792 13.5652 10.9564C13.5652 11.2444 13.7989 11.4781 14.0869 11.4781C14.3749 11.4781 14.6087 11.2444 14.6087 10.9564C14.6087 10.0934 15.3109 9.39113 16.1739 9.39113C17.0368 9.39113 17.7391 10.0934 17.7391 10.9564C17.7391 11.2444 17.9728 11.4781 18.2608 11.4781C18.5488 11.4781 18.7826 11.2444 18.7826 10.9564C18.7826 9.51792 17.6123 8.34766 16.1739 8.34766Z" fill="#568357"/>
                                        <path d="M9.3912 10.9564C9.3912 11.2444 9.62494 11.4781 9.91294 11.4781C10.2009 11.4781 10.4347 11.2444 10.4347 10.9564C10.4347 9.51792 9.26442 8.34766 7.82598 8.34766C6.38755 8.34766 5.21729 9.51792 5.21729 10.9564C5.21729 11.2444 5.45102 11.4781 5.73902 11.4781C6.02702 11.4781 6.26076 11.2444 6.26076 10.9564C6.26076 10.0934 6.96302 9.39113 7.82598 9.39113C8.68894 9.39113 9.3912 10.0934 9.3912 10.9564Z" fill="#568357"/>
                                    </svg>
                                </div>
                                <div v-if="lang === 'ru'" class="label">Благодарим за ответ!</div>
                                <div v-if="lang === 'kk'" class="label">Жауап бергеніңізге рақмет !</div>
                            </div>
                        </div>
                        <div @click="expandQuestion(data.id)" class="more-info">
                            <svg :id="'icon-' + data.id" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M28.8281 13.8281H16.1719V1.17188C16.1719 0.524648 15.6472 0 15 0C14.3528 0 13.8281 0.524648 13.8281 1.17188V13.8281H1.17188C0.524648 13.8281 0 14.3528 0 15C0 15.6472 0.524648 16.1719 1.17188 16.1719H13.8281V28.8281C13.8281 29.4754 14.3528 30 15 30C15.6472 30 16.1719 29.4754 16.1719 28.8281V16.1719H28.8281C29.4754 16.1719 30 15.6472 30 15C30 14.3528 29.4754 13.8281 28.8281 13.8281Z" fill="#568357"/>
                            </svg>
                        </div>
                        <div class="sep-line"></div>
                    </div>
                </div>
                <div v-if="lang === 'ru' && dataFAQ.length" class="paging">
                    <paginate
                        :page-count="parseInt(dataFAQ.length / 4)"
                        :page-range="4"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Пред.'"
                        :next-text="'След.'"
                        :page-link-class="'a-item'"
                        :active-class="'active-item'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>
                </div>
                <div v-if="lang === 'kk' && dataFAQ.length" class="paging">
                    <paginate
                        :page-count="parseInt(dataFAQ.length / 4)"
                        :page-range="4"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Артқа.'"
                        :next-text="'Алға.'"
                        :page-link-class="'a-item'"
                        :active-class="'active-item'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                    </paginate>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { api } from '../../variables.js'
import json from '../common/en-ru.json'
import jsonKz from '../common/en-kz.json'
import Paginate from 'vuejs-paginate'

export default {
    props: [ 'data' ],
    components: {
        'paginate': Paginate
    },
    data(){
        return {
            active: false,
            active2: false,
            active3: false,
            active4: false,
            sentFeedback: false,
            currentPage: 0,
            pageNum: 1,
            dataFAQ: [],
            activeFAQ: '',
            filter: 'mybody',
            translate: '',
            translateKz: '',
            lang: 'kk',
            loading: false
        }
    },
    created: function () {
        if( localStorage.getItem('xyzCustomLang') ){
            this.lang = localStorage.getItem('xyzCustomLang')
        }
        this.init()
        this.getFAQ()
        this.translate = json
        this.translateKz = jsonKz
    },
    watch:{
        '$route' () {
            this.init()
            this.getFAQ()
        },
    },        
    methods: {
        init(){
            this.filter = this.$route.query.filter || this.filter
        },
        clickCallback(pageNum) {
            this.pageNum = pageNum
            this.activeFAQ = this.dataFAQ.slice(4 * pageNum - 4, 4 * pageNum)
        },
        getFAQ(){
            this.loading = true
            axios.get( api + '/mhealth/jsonapi/node/srh_content/?filter[field_country.name]=KAZ&filter[blue-and][group][conjunction]=AND&filter[red-and][group][conjunction]=AND&filter[blue][condition][path]=field_tags.name&filter[blue][condition][memberOf]=blue-and&filter[red][condition][path]=field_tags.name&filter[red][condition][memberOf]=red-and&filter[red][condition][value]=' + this.filter + '&filter[blue][condition][value]=qaKZ&filter[langcode]=' + this.lang + '&sort=-created&page[offset]=0' )
            .then((res) => {
                // console.log(res.data.data)
                this.dataFAQ = res.data.data
                this.activeFAQ = this.dataFAQ.slice(0, 4)
                this.loading = false
            })
            .catch((e) => {
                this.loading = false
                console.log('Error in loading news\n' + e)
            })
        },
        expandQuestion(id){
            var q_section = document.getElementById(id)
            var q_icon = document.getElementById('icon-' + id)
            var q = q_section.getElementsByTagName('p')[0]
            q_section.getElementsByClassName('on-click-active').forEach( item => {
                if( item.style.display === 'flex'){
                    item.style.display = 'none'
                } else {
                    item.style.display = 'flex'
                }
            })
            if(q.classList.contains('active')){
                q.classList.remove('active')
            } else {
                q.classList.add('active')
            }
            if(q_icon.classList.contains('rotated')){
                q_icon.classList.remove('rotated')
            } else {
                q_icon.classList.add('rotated')
            }
        },
        showTagList(){
            if(window.screen.width <= 1024){
                var q = document.getElementsByClassName('left')[0]
                if(q.style.display === "flex"){
                    q.style.display = "none";
                } else {
                    q.style.display = "flex";
                }
            }
        },
        pageChange (page) {
            this.page = page;
            console.log(page);
        },
        rangeChange (start, end) {
            console.log(start, end);
        },
    },
}
</script>
<style lang="scss" scoped>
    h1, h3, p, span, a{
        cursor: default;
        text-decoration: none;
        text-align: left;
        margin: 0;
    }
    .outer{
        padding: 30px 12% 100px 12%;
        h1{
            font-weight: 500;
            font-size: 34px;
            line-height: 45px;
            letter-spacing: 0.04em;
        }
        .tag-mobile{
            display: none;
        }
        .content{
            margin-top: 30px;
            height: auto;
            .left{
                width: 320px;
                .category{
                    padding: 18px 0;
                    width: 320px;
                    background: #F6F4EB;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    .category-item{
                        cursor: pointer;
                        padding: 12px 12px 12px 12px;
                        font-weight: 500;
                        font-size: 20px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #568357;
                    }
                    .category-item:hover, .active{
                        background: #568357;
                        color: #FFFFFF;
                    }
                    
                }
                .not-found{
                    margin-top: 10px;
                    padding: 20px 25px;
                    width: 270px;
                    background: #F6F4EB;
                    box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                    border-radius: 10px;
                    span{
                        font-weight: 300;
                        font-size: 20px;
                        line-height: 26px;
                        letter-spacing: 0.04em;
                        color: #4F4F4F;
                    }
                    .ask-q{
                        cursor: pointer;
                        margin-top: 20px;
                        padding: 23px 0;
                        background: #568357;
                        border-radius: 10px;
                        width: 270px;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 26px;
                        text-align: center;
                        letter-spacing: 0.04em;
                        color: #FFFFFF;
                    }
                }
            }
            .right{
                width: calc( 95% - 320px);
                margin-left: 5%;
                .questions-list{
                    width: 100%;
                    .question-item{
                        margin-bottom: 30px;
                        position: relative;
                        .info{
                            width: calc(100% - 60px);
                            h3{
                                font-weight: 500;
                                font-size: 24px;
                                line-height: 45px;
                                letter-spacing: 0.04em;
                                color: #568357;
                            }
                            p{
                                margin-top: 10px;
                                height: 50px;
                                font-weight: 300;
                                font-size: 18px;
                                line-height: 25px;
                                letter-spacing: 0.03em;
                                // display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            .on-click-active{
                                display: none;
                            }
                            .feedback-text{
                                margin-top: 40px;
                                font-weight: 500;
                                font-size: 18px;
                                line-height: 25px;
                                letter-spacing: 0.03em;
                                color: #333333;
                            }
                            .feedback-btns{
                                margin-top: 16px;
                                .option{
                                    z-index: 99;
                                    cursor: pointer;
                                    margin-right: 20px;
                                    text-align: center;
                                    padding: 13px 0;
                                    width: 120px;
                                    border-radius: 10px;
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 26px;
                                    text-align: center;
                                    letter-spacing: 0.04em;
                                }
                                .option.yes{
                                    border: 2px solid #FFFFFF;
                                    background: #568357;
                                    color: #FFFFFF;
                                }
                                .option.no{
                                    background: #FFFFFF;
                                    border: 2px solid #568357;
                                    color: #568357;
                                }
                                .icon{
                                    margin-left: 16px;
                                }
                                .label{
                                    cursor: default;
                                    margin-left: 10px;
                                    font-weight: 500;
                                    font-size: 18px;
                                    line-height: 25px;
                                    letter-spacing: 0.03em;
                                    color: #568357;
                                }
                            }

                        }
                        .more-info{
                            cursor: pointer;
                            position: absolute;
                            right: 0;
                            top: 38px;
                            svg{
                                transition: transform 0.5s;
                            }
                            .rotated{
                                transform: rotate(45deg);
                                transition: transform 0.5s;
                            }
                        }
                        .sep-line{
                            margin-top: 20px;
                            border: 1px solid #BDBDBD;
                        }
                    }
                }
                .paging{
                    margin: 10px auto 0 auto;
                    .pagination {
                        list-style: none;
                        display: flex;
                        flex-direction: row;
                    }

                }
            }
        }
    }
    .paging{
        position: absolute;
        bottom: 20px;
    }
    @media only screen and (max-width: 1330px){
        .outer{
            padding: 30px 8% 100px 8%;
        }
    }
    @media only screen and (max-width: 1024px){
        .outer{
            padding: 30px 12% 100px 12%;
            min-height: 720px;
            h1{
                font-weight: 500;
                font-size: 34px;
                line-height: 45px;
                letter-spacing: 0.04em;
            }
            .tag-mobile{
                cursor: pointer;
                display: flex;
                text-align: left;
                div{
                    font-weight: 800;
                    font-size: 16px;
                    line-height: 45px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
            }
            .content{
                position: relative;
                margin-top: 10px;
                .left{
                    top: -15px;
                    z-index: 98;
                    display: none;
                    position: absolute;
                    width: 320px;
                    .category{
                        padding: 18px 0;
                        width: 320px;
                        background: #568357;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        .category-item{
                            cursor: pointer;
                            padding: 12px 12px 12px 12px;
                            font-weight: 500;
                            font-size: 20px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            color: #FFFFFF;
                        }
                        .category-item:hover, .active{
                            background: #F0DCC4;
                            color: #568357;
                        }
                    }
                    .not-found{
                        display: none;
                    }
                }
                .right{
                    width: calc( 100%);
                    margin-left: 0;
                    .questions-list{
                        width: 100%;
                        .question-item{
                            margin-bottom: 30px;
                            position: relative;
                            .info{
                                width: calc(100% - 60px);
                                h3{
                                    font-weight: 500;
                                    font-size: 24px;
                                    line-height: 45px;
                                    letter-spacing: 0.04em;
                                    color: #568357;
                                }
                                p{
                                    margin-top: 10px;
                                    height: 50px;
                                    font-weight: 300;
                                    font-size: 18px;
                                    line-height: 25px;
                                    letter-spacing: 0.03em;
                                    // display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                .on-click-active{
                                    display: none;
                                }
                                .feedback-text{
                                    margin-top: 10px;
                                    font-weight: 500;
                                    font-size: 18px;
                                    line-height: 25px;
                                    letter-spacing: 0.03em;
                                    color: #333333;
                                }
                                .feedback-btns{
                                    margin-top: 6px;
                                    .option{
                                        z-index: 99;
                                        cursor: pointer;
                                        margin-right: 20px;
                                        text-align: center;
                                        padding: 13px 0;
                                        width: 120px;
                                        border-radius: 10px;
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 26px;
                                        text-align: center;
                                        letter-spacing: 0.04em;
                                    }
                                    .option.yes{
                                        border: 2px solid #FFFFFF;
                                        background: #568357;
                                        color: #FFFFFF;
                                    }
                                    .option.no{
                                        background: #FFFFFF;
                                        border: 2px solid #568357;
                                        color: #568357;
                                    }
                                    .icon{
                                        margin-left: 16px;
                                    }
                                    .label{
                                        cursor: default;
                                        margin-left: 10px;
                                        font-weight: 500;
                                        font-size: 18px;
                                        line-height: 25px;
                                        letter-spacing: 0.03em;
                                        color: #568357;
                                    }
                                }

                            }
                            .more-info{
                                cursor: pointer;
                                position: absolute;
                                right: 0;
                                top: 38px;
                                svg{
                                    transition: transform 0.5s;
                                }
                                .rotated{
                                    transform: rotate(45deg);
                                    transition: transform 0.5s;
                                }
                            }
                            .sep-line{
                                margin-top: 20px;
                                border: 1px solid #BDBDBD;
                            }
                        }
                    }
                    .paging{
                        margin: 10px auto 0 auto;
                        .pagination {
                            list-style: none;
                            display: flex;
                            flex-direction: row;
                        }

                    }
                }
            }
        }
    }
    @media only screen and (max-width: 720px){
        .outer{
            padding: 20px 6% 80px 6%;
            min-height: 720px;
            h1{
                font-weight: 500;
                font-size: 24px;
                line-height: 38px;
                letter-spacing: 0.04em;
            }
            .tag-mobile{
                display: flex;
                text-align: left;
                div{
                    font-weight: 800;
                    font-size: 16px;
                    line-height: 45px;
                    letter-spacing: 0.04em;
                    color: #568357;
                }
            }
            .content{
                position: relative;
                margin-top: 10px;
                .left{
                    top: -15px;
                    z-index: 98;
                    display: none;
                    position: absolute;
                    width: 280px;
                    .category{
                        padding: 18px 0;
                        width: 250px;
                        background: #568357;
                        box-shadow: 5px 20px 50px rgba(94, 115, 97, 0.35);
                        border-radius: 10px;
                        .category-item{
                            cursor: pointer;
                            padding: 8px 12px;
                            font-weight: 500;
                            font-size: 16px;
                            line-height: 26px;
                            letter-spacing: 0.04em;
                            color: #FFFFFF;
                        }
                        .category-item:hover, .active{
                            background: #F0DCC4;
                            color: #568357;
                        }
                        
                    }
                    .not-found{
                        display: none;
                    }
                }
                .right{
                    width: calc( 100%);
                    margin-left: 0;
                    .questions-list{
                        width: 100%;
                        .question-item{
                            margin-bottom: 15px;
                            position: relative;
                            .info{
                                width: calc(100% - 60px);
                                .on-click-active{
                                    display: none;
                                }
                                .feedback-text{
                                    margin-top: 10px;
                                    font-weight: 500;
                                    font-size: 16px;
                                    line-height: 20px;
                                    letter-spacing: 0.03em;
                                    color: #333333;
                                }
                                .feedback-btns{
                                    margin-top: 6px;
                                    .option{
                                        z-index: 99;
                                        cursor: pointer;
                                        margin-right: 20px;
                                        text-align: center;
                                        padding: 8px 0;
                                        width: 120px;
                                        border-radius: 10px;
                                        font-weight: 500;
                                        font-size: 14px;
                                        line-height: 20px;
                                        text-align: center;
                                        letter-spacing: 0.04em;
                                    }
                                    .option.yes{
                                        border: 2px solid #FFFFFF;
                                        background: #568357;
                                        color: #FFFFFF;
                                    }
                                    .option.no{
                                        background: #FFFFFF;
                                        border: 2px solid #568357;
                                        color: #568357;
                                    }
                                    .icon{
                                        margin-left: 16px;
                                    }
                                    .label{
                                        cursor: default;
                                        margin-left: 10px;
                                        font-weight: 500;
                                        font-size: 14px;
                                        line-height: 25px;
                                        letter-spacing: 0.03em;
                                        color: #568357;
                                    }
                                }

                            }
                            .more-info{
                                cursor: pointer;
                                position: absolute;
                                right: 0;
                                top: 10px;
                                svg{
                                    transition: transform 0.5s;
                                    transform: scale(0.7);
                                }
                                .rotated{
                                    transform: rotate(45deg) scale(0.7);
                                    transition: transform 0.5s;
                                }
                            }
                            .sep-line{
                                margin-top: 10px;
                                border: 1px solid #BDBDBD;
                            }
                        }
                    }
                    .paging{
                        margin: 10px auto 0 auto;
                        .pagination {
                            list-style: none;
                            display: flex;
                            flex-direction: row;
                        }

                    }
                }
            }
        }
    }
</style>


